import {FacturesVosFiltresComponent} from "./pages/factures/filtres/vos-filtres/vos-filtres.component";
import {FacturesResultatsComponent} from "./pages/factures/resultats/factures-resultats.component";
import {FacturesFiltresComponent} from "./pages/factures/filtres/factures-filtres.component";
import {FacturesComponent} from "./pages/factures/factures.component";
import {NotificationNumberResolver} from "./notification.resolver";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {AccessResolver} from "./check.resolver";
import { ProfilValideResolver } from "./profil-valide.resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    resolve: {
      check: AccessResolver,
      nbAlerts: NotificationNumberResolver,
      profilValide: ProfilValideResolver,
    },
    children: [
      {
        path: 'factures',
        component: FacturesComponent
      },
      {path: '', redirectTo: 'factures', pathMatch: 'full'}]
  },
  {path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard]},
  {path: '', redirectTo: 'cerba', pathMatch: 'full'}
];

@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    FacturesComponent,
    FacturesFiltresComponent,
    FacturesResultatsComponent,
    FacturesVosFiltresComponent
  ],
  entryComponents: [],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, {useHash: true}),
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessResolver,
    NotificationNumberResolver,
    ProfilValideResolver
  ]
})
export class CerbaRoutingModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts